import { useEffect, useRef } from "react";

const ADS_CLIENT = "ca-pub-6960235883352692";
const ADS_SLOT = "3183600173";

const AdSenseUnit = ({
  slot = ADS_SLOT,
  className = "",
  label = "Sponsored",
}) => {
  const adRef = useRef(null);
  const hasPushedRef = useRef(false);

  useEffect(() => {
    if (!adRef.current || hasPushedRef.current) {
      return;
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      hasPushedRef.current = true;
    } catch (error) {
      console.error("AdSense push failed", error);
    }
  }, []);

  return (
    <div className={`rounded-3xl border border-white/10 bg-white/[0.03] p-4 ${className}`.trim()}>
      <p className="mb-3 text-center text-[11px] uppercase tracking-[0.3em] text-white/40">
        {label}
      </p>
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADS_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSenseUnit;
